// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const AuditCount = t.struct({
    auditsDueIn30Days: t.maybe(t.Number),
    pastDueAudits: t.maybe(t.Number)
}, {
    name: 'AuditCount',
    strict: true
});

export const getDefaultState = () => new AuditCount({
    auditsDueIn30Days: null,
    pastDueAudits: null
});

export default AuditCount;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/audit-count.js